import {Component, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {AppInfoService} from "../../../shared/services/general";
import {ActivatedRoute, Router} from "@angular/router";
import {DxFormComponent} from "devextreme-angular";
import {RecoveryViewModel} from "../../../shared/models/general";
import {PatientBillingService} from "../../../modules/features/billing/services/patient-billing.service";
import {takeUntil} from "rxjs/operators";
import notify from "devextreme/ui/notify";
import {HttpResponse} from "@angular/common/http";
import {Subject} from "rxjs";

@Component({
  selector: 'app-secret-code-invoice-verification',
  templateUrl: './secret-code-invoice-verification.component.html',
  styleUrls: ['./secret-code-invoice-verification.component.scss']
})
export class SecretCodeInvoiceVerificationComponent implements OnInit, OnDestroy {
  @ViewChild(DxFormComponent, {static: true}) public form?: DxFormComponent;
  public formData: { secretCode: string | null } = {secretCode: null};
  private onDestroy$ = new Subject<void>();

  constructor(
    private service: PatientBillingService,
    private route: ActivatedRoute,
    private applicationInfo: AppInfoService,
    private router: Router,) {
  }

  ngOnDestroy(): void {
    this.onDestroy$.complete();
  }

  ngOnInit(): void {
    this.route.queryParams.pipe(takeUntil(this.onDestroy$)).subscribe(params => {
      if (params['code']) {
        this.formData.secretCode = params['code'];
      }
    });
  }

  public async redirectToLogin() {
    await this.router.navigateByUrl('/login');
  }

  public formSubmitted(event: any): void {
    event.preventDefault();
    if (this.form?.instance.validate().isValid && this.formData.secretCode) {
      this.service.getPatientIdByInvoiceSecret(this.formData.secretCode).subscribe(async (response: any) => {
        if (Number.isNaN(response)) {
          notify('There is not any pending invoices registered with the introduced secret code', 'error', 10000);
          return;
        }
        const patientId = +response;
        await this.router.navigateByUrl(`/billing?patientId=${patientId}`);
      }, error => {
        if (error.status === 404) {
          notify('There is not any pending invoices registered with the introduced secret code', 'error', 10000);
        } else {
          notify('We are having trouble to succeed your request!', 'error', 3000);
        }
      });
    }
  }

  public get Logo(): string {
    return this.applicationInfo.logo;
  }

  public get Lab(): string {
    return this.applicationInfo.lab;
  }
}
